import { createSharedComposable, useLocalStorage } from "@vueuse/core";

export const useSidebar = createSharedComposable(() => {
  const isSidebarCollapsed = useLocalStorage("sidebar-collapsed", false);

  const toggleSidebarCollapse = () => {
    isSidebarCollapsed.value = !isSidebarCollapsed.value;
  };

  const collapseSidebar = () => {
    isSidebarCollapsed.value = true;
  };

  const expandSidebar = () => {
    isSidebarCollapsed.value = false;
  };

  return {
    isSidebarCollapsed,
    toggleSidebarCollapse,
    collapseSidebar,
    expandSidebar,
  };
});
